import Button from "../form/button";
import toast from "react-hot-toast";
import React, { useEffect, useState } from "react";
import { RootState } from "../../app/store";
import { classNames } from "../../utils/utils";
import { RiHandCoinFill } from "react-icons/ri";
import wave from "./../../assets/icon/wave.png";
import { useNavigate } from "react-router-dom";
import { formatMoney } from "../../utils/format";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import {
  dismissTransactionModal,
  setPaymentMode,
  toggleValidationModal,
} from "../../features/payments/paymentsSlice";
import { ReactComponent as OrangeMoney } from "./../../assets/icon/orange_money.svg";
import { useMutation } from "@apollo/client";
import { CREATE_ORDER } from "../../api/orders/mutations";
import { resetCart } from "../../features/cart/cartSlice";
import CardList from "../card/cardlist";

interface Props {
  products?: any[];
}

const UpSell = (props: Props) => {
  const products = props.products;

  useEffect(() => {
    toast.success("Découvrez des produits similaires...", {
      duration: 10000,
    });
  }, []);

  return (
    <>
      <div className="bg-gray-50 flex justify-center items-center flex-col py-7 h-auto border">
        <div className="flex justify-center items-center bg-white w-full">
          <span className="font-bold text-pretty text-2xl">
            Produits similaires
          </span>
        </div>

        <div className="flex justify-center items-center flex-col overflow-y-scroll scrollbar-hide">
          <CardList products={products} />
        </div>
      </div>
    </>
  );
};

export default UpSell;
